import React, { useState } from 'react';
import { Employee } from "../api/EmployeeApi";
import { useTranslation } from "react-i18next";
import { appConfig } from "../config";

interface EmployeeAvatarProps {
    employee: Employee;
    size?: number;
}

const EmployeeAvatar: React.FC<EmployeeAvatarProps> = ({ employee, size }) => {

    const { t } = useTranslation();
    const avatarSize = size || 28;
    const src = employee?.avatar ? `${appConfig.backendUrl}/api/users/avatars/${employee.avatar}` : null;
    const alt = employee.preferredName || t('employees.avatar.defaultAltText');
    const [imageError, setImageError] = useState(false);

    const getInitials = () => {
        const first = employee?.firstname?.trim();
        const last = employee?.lastname?.trim();

        if (!first && !last) return "?";

        const firstInitial = first?.[0]?.toUpperCase() || "";
        const lastInitial = last?.[0]?.toUpperCase() || "";

        return (firstInitial + lastInitial) || "?";
    };

    const initials = getInitials();

    return (
        <div
            style={{
                width: `${avatarSize}px`,
                height: `${avatarSize}px`,
                borderRadius: "50%",
                overflow: "hidden",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#ccc",
                fontSize: avatarSize * 0.4,
                fontWeight: 600,
                color: "white",
                textTransform: "uppercase",
            }}
        >
            {src && !imageError ? (
                <img
                    src={src}
                    alt={alt}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    onError={() => setImageError(true)}
                />
            ) : (
                <span>{initials}</span>
            )}
        </div>
    );
};

export default EmployeeAvatar;
